import { useEffect, useState } from "react";
import { RoleMasterFilterType } from "../../models/DashboardModels";
import { CLICK_ACTIONS, DEFAULT_OPTION } from "../../utils/Constant";
import Footer from "../../components/Footer";
import TableComponent from "../../components/TableComponent";
import { ROLE_MASTER_HEADERS, ROLE_PERMISSION_HEADERS } from "./RoleMasterHelper";
import { ColumnHeaderType, LoggedUserType } from "../../utils/Types";
import RoleMasterFilters from "../../filters/RoleMasterFilters";
import '../../assets/style/RoleMaster.css';
import UpdateRole from "./components/UpdateRole";
import { handleStoreCreateRoleRes, handleStoreDeleteRoleRes, handleStoreEditRoleRes, handleStoreGroupRoles, handleStoreRoleStatus, handleStoreUpdateRoleRes} from "../../redux/slices/roleMasterSlice";
import { useDispatch, useSelector } from "react-redux";
import { getAllPermissions, getPermissionsByRole, getRoleMasterApi } from "../../api/roleMasterApi";
import CenterSpinner from "../../components/CenterSpinner";
import ActiveSessionModal from "../../modals/ActiveSessionModal";
import CreateRole from "./components/CreateRole";
import { lineOfBusinessMastersApi } from "../../api/grievancesApi";
import DeleteRoleConfirmModal from "../../modals/DeleteRoleConfirmModal";
import EditRoleModal from "../../modals/EditRoleModal";
import { loginSelector } from "../../redux/slices/loginSlice";
import { blankValueGetter } from "../../utils/Util";

const RoleMaster = () => {
    const [selectedFilter, setSelectedFilter] = useState<RoleMasterFilterType>(
        {
            roleName: "ALL",
            roleId: "All",
            roleStatus: DEFAULT_OPTION,
            lineOfBusiness: DEFAULT_OPTION,
        }
    );
    const [count, setCount] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [limitStart, setLimitStart] = useState(0);
    const [limitSelected, setLimitSelected] = useState(25);
    const [showUpdateRole, setShowUpdateRole] = useState(false);
    const [showCreateRole, setShowCreateRole] = useState(false);
    const [showPermissionsSection, setShowPermissionsSection] = useState(false);
    const [roleData, setRoleData] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [flag, setFlag] = useState(false);
    const [showRole, setShowRole] = useState(true);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [selectedRole, setSelectedRole] = useState<any>(null);
    const [roleAction, setRoleAction] = useState<'edit_role' | 'delete_role' | null>(null);
    const user: LoggedUserType = useSelector(loginSelector).user;
    const [tableHeaders, setTableHeaders] = useState(ROLE_MASTER_HEADERS);

    const {
        storeRoleMasterData,
        showLoader,
        storeGroupRoles,
      } = useSelector((state: any) => state.roleMaster);

    const roleMasterData = storeRoleMasterData ?? undefined

    const enhancedRoleData = roleMasterData?.groups?.map((role: any) => ({
        ...role,
    }));

    const roleStatusList = [
        {label:'Active', value: 1},
        {label:'Inactive', value: 2}
    ];

    const dispatch : any = useDispatch();

    useEffect(() => {
        dispatch(handleStoreRoleStatus(roleStatusList));
        dispatch(getAllPermissions());
        dispatch(lineOfBusinessMastersApi())
    },[])

    useEffect(() => {
        setTotalCount(roleMasterData ? roleMasterData?.totalRecordsCount : 0)
        setCount(roleMasterData?.groups?.length || 0);
    }, [roleMasterData])

    useEffect(() => {
        setTimeout(() => {
            getRoleMasterData();
        }, 100)
    }, [limitStart, limitSelected])

    useEffect(() => {
        if (limitStart > 0) {
            setLimitStart(0)
        }
        else {
            setTimeout(() => {
                getRoleMasterData();
            }, 100)
        }
    }, [selectedFilter])

    const getRoleMasterData = () => {
        dispatch(getRoleMasterApi(selectedFilter, limitSelected, limitStart));
    }

    const changePaginationLimit = (value: number) => {
        setLimitSelected(Number(value))
    };
    
    const prevPage = () => {
        if (limitStart >= limitSelected) {
            setLimitStart(limitStart - limitSelected)
        }
    };
    const nextPage = () => {
        if (roleMasterData?.groups?.length == limitSelected) {
            setLimitStart(limitStart + limitSelected);
        }
    };

    const onTableAction = (role: any, headerItem: ColumnHeaderType) => {
        if (headerItem.action === CLICK_ACTIONS.VIEW_PERMISSIONS) {
            setIsLoading(true);
            setRoleData(role)
            dispatch(getPermissionsByRole(role.name))
            setShowRole(false);
        } 
        else if (headerItem.action === CLICK_ACTIONS.MODIFY_ROLE) {
            setSelectedRole(role);
        }
    };

    useEffect(()=>{
        if(!showPermissionsSection) { 
            dispatch(handleStoreGroupRoles([]));
            dispatch(handleStoreCreateRoleRes([]));
            dispatch(handleStoreUpdateRoleRes([]));
            if(flag){
                setTimeout(() => {
                    getRoleMasterData();
                }, 100)
            }
        }
    },[showPermissionsSection])

    useEffect(()=>{
        if(storeGroupRoles?.data != undefined && storeGroupRoles?.data.length >= 0 && !showRole){
            setShowUpdateRole(true);
            setShowCreateRole(false);
            setShowPermissionsSection(!showPermissionsSection);
            setIsLoading(false);
        }
    },[storeGroupRoles])

    useEffect(() => {
        setIsLoading(showLoader);
    },[showLoader])

    useEffect(() => {
        if(roleAction === CLICK_ACTIONS.DELETE_ROLE) {
            setOpenDeleteModal(true);
        }
        else if(roleAction === CLICK_ACTIONS.EDIT_ROLE) {
            setOpenEditModal(true);
        }
    },[roleAction])

    const toggleDeleteModal = () => {
        setOpenDeleteModal(!openDeleteModal);
        if(openDeleteModal) {
            setRoleAction(null);
            dispatch(handleStoreDeleteRoleRes({}));
            if (flag) {
                setTimeout(() => {
                    getRoleMasterData();
                    setFlag(false);
                }, 100)
            }
        }
    }

    const toggleEditModal = () => {
        setOpenEditModal(!openEditModal);
        if(openEditModal) {
            setRoleAction(null);
            dispatch(handleStoreEditRoleRes({}));
            if (flag) {
                setTimeout(() => {
                    getRoleMasterData();
                    setFlag(false);
                }, 100)
            }
        }
    }

    
    useEffect(() => {
        const headers = (user?.permissions?.includes('delete-role') || user?.permissions?.includes('update-role'))
            ? [...ROLE_MASTER_HEADERS,
            {
                name: 'Actions',
                field: 'actions',
                sortable: false,
                valueGetter: blankValueGetter,
                action: CLICK_ACTIONS.MODIFY_ROLE,
                clickable: true,
            }]
            : ROLE_MASTER_HEADERS;
        setTableHeaders(headers);
    }, [user])

    return (
        <>
            <div style={{ marginBottom: '66px', overflow: 'auto' }}>
                <p className="page-header">Role Master</p>
                {showPermissionsSection ?
                    <>
                        {showUpdateRole && 
                            <UpdateRole 
                                roleData={roleData}
                                setShowPermissionsSection={setShowPermissionsSection}
                                setFlag={setFlag}
                            />
                        }
                        {showCreateRole && 
                            <CreateRole 
                                setShowPermissionsSection={setShowPermissionsSection}
                                setFlag={setFlag}
                            />
                        }
                    </>
                    :
                    <>
                        <RoleMasterFilters onApplyFilters={setSelectedFilter} />
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <button 
                                className='create-grievance' 
                                onClick={() => {
                                    setShowCreateRole(true);
                                    setShowUpdateRole(false);
                                    setShowPermissionsSection(!showPermissionsSection);
                                }}
                            >
                                Create Role
                            </button>
                        </div>

                        <div className="table-container2">
                            <TableComponent 
                                onAction={onTableAction}
                                data={enhancedRoleData} 
                                style={{ marginBottom: '66px' }}
                                columnHeaders={tableHeaders}
                                setRoleAction={setRoleAction}
                            />
                            
                            {storeRoleMasterData && storeRoleMasterData.length === 0 &&
                                <p className="nodata">Data Not Found</p>
                            }
                        </div>

                        <Footer
                            count={count} 
                            totalCount={totalCount}
                            changePaginationLimit={changePaginationLimit}
                            nextPage={nextPage}
                            prevPage={prevPage}
                            limitSelected={limitSelected}
                            limitStart={limitStart}
                        />  
                    </>       
                }       
            </div>
            <CenterSpinner showLoader={isLoading} />
        {openDeleteModal && (
            <DeleteRoleConfirmModal
                openModal={openDeleteModal}
                toggle={toggleDeleteModal}
                role={selectedRole}
                setFlag={setFlag}
            />
        )}
        {openEditModal && (
            <EditRoleModal
                openModal={openEditModal}
                toggle={toggleEditModal}
                role={selectedRole}
                setFlag={setFlag}
            />
        )}
        </>
    );
}

export default RoleMaster;